import useAlertStatus from './useAlertStatus';
import useCtaButtonState from './useCtaButtonState';
import useIsAvailabilityDisabled from './useIsAvailabilityDisabled';
import useIsReservableVehicle from './useIsReservableVehicle';

export default function useIsNotAvailableForImmediatePurchase() {
  const { notifyMe } = useCtaButtonState();
  const isReservableVehicle = useIsReservableVehicle();
  const isAvailabilityDisabled = useIsAvailabilityDisabled();
  const { isSold } = useAlertStatus();

  return Boolean(isAvailabilityDisabled || isReservableVehicle || notifyMe || isSold);
}
